import React, { Component } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';
import { UAParser } from 'ua-parser-js'
import { Base64 } from 'js-base64'

const initialState = {
    deviceList: [],
    credentialName: '－',
    complete: false,
    errorMap: null,
    loading: false,
    webAuthnFlg: true
}

class PasskeySetting extends Component {
    state = initialState;

    componentDidMount() {
        // パスキー一覧を取得する
        this.getDeviceList()

        // デバイス情報を取得する
        this.getUA()

        // WebAuthn対応有無確認
        let winUserAgent = window.navigator.userAgent
        let userAgentExcludeList = process.env.REACT_APP_USERAGENT_EXCLUDE_LIST.split(',');
        for (let data of userAgentExcludeList) {
          if (winUserAgent.indexOf(data) !== -1) {
            this.setState({
                webAuthnFlg: false
            })
            break;
          }
        }
        if (!(typeof window.PublicKeyCredential === 'function')) {
            this.setState({
                webAuthnFlg: false
            })
        }

        // GA計測用データレイヤースクリプトを追加する
        window.addDataLayerScript('jmbauth_passkey_setting');
    }

    // パスキー一覧取得処理
    getDeviceList = () => {
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        try {
            // ローディング開始
            this.setState({ loading: true })

            // FIDO2クレデンシャル情報参照APIを呼出す
            axios
                .get(process.env.REACT_APP_URL_CO_SC_API_CREDENTIAL_INFO,
                    {
                        headers: {
                            'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                            'Cache-Control': 'no-store',
                            'Pragma': 'no-cache'
                        }
                    }
                )
                .then((response) => {
                    // ユーザ情報リスト
                    const userInfoList = response.data
                    this.setState({
                        deviceList: userInfoList,
                        errorMap: '',
                        loading: false
                    })
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 400) {
                            this.setState({
                                errorMap:
                                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                                deviceList: []
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 401) {
                            this.setState({
                                errorMap:
                                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                                deviceList: []
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 500) {
                            // エラー画面に遷移し、処理を終了する
                            this.props.history.push({
                                pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                            });
                        }
                        else {
                            this.setState({
                                errorMap:
                                    { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                                deviceList: []
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                    }
                    else {
                        this.setState({
                            errorMap:
                                { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                            loading: false,
                            deviceList: []
                        });
                        // エラーメッセージ表示領域に遷移する
                        window.location = "#JS_error";
                    }
                })
        } catch (error) {
            console.error(error);
            this.setState({
                errorMap:
                    { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                loading: false,
                deviceList: []
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
        } finally {
        }

    }

    // ユーザーエージェント取得処理
    getUA = async () => {
        const result = UAParser()

        // デバイス名判定
        let deviceName;
        if (result && result.device && result.device.model) {
            if (result.device.model === 'K' && result.browser.name === 'Chrome') {
                await navigator.userAgentData.getHighEntropyValues(['model']).then((ua) => {
                    deviceName = ua.model ? ua.model : ua.platform;
                })
            } else if (result.device.model === 'K') {
                deviceName = result.os.name ? result.os.name : '－';
            } else {
                deviceName = result.device.model;
            }
        } else if (result && result.os && result.os.name) {
            deviceName = result.os.name;
        } else {
            deviceName = '－';
        }

        // クレデンシャル名設定
        if (deviceName) {
            this.setState({ credentialName: deviceName });
        } else {
            this.setState({ credentialName: '－' });
        }
    }

    // 変更するボタン押下処理
    toPasskeyChange = (device) => {
        this.props.history.push({
            pathname: `${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/name_change`,
            state: {
                credentialId: device.credentialId,
                credentialName: device.credentialName
            }
        })
    }

    // 削除するボタン押下処理
    toPasskeyDelete = (device) => {
        this.props.history.push({
            pathname: `${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/delete`,
            state: {
                credentialId: device.credentialId,
                credentialName: device.credentialName,
                regDate: this.formatDate(device.regDate)
            }
        })
    }

    // 閉じるボタン押下処理
    close = e => {
        window.open('about:blank', '_self').close();
    }

    // 新規登録するボタン押下処理
    register = async () => {
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // Cookieからl_sidを取得する
        let l_sid = window.getCookieValue('l_sid');

        // アクショントークン格納変数の宣言
        let actionToken = null;
        // セッショントークン格納変数の宣言
        let sessionToken;

        // SDK呼出(アクションレポート)
        try {
            // アクションのレポート作成
            const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_passkey_add", { correlationId: l_sid });

            // タイムアウト判定関数
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    reject(new Error('Action token request timed out'));
                }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
            });

            // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
            const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
            actionToken = actionResponse ? actionResponse.actionToken : null;
        } catch (e) {
            // タイムアウト時の処理
            if (e.message.includes('timed out')) {
                // エラー文言を、アクショントークン変数に設定
                actionToken = 'jallogin_transmit_api_timeout';
            }
        }

        // SDK呼出(セッショントークン取得)
        try {
            // セッショントークン取得
            sessionToken = await window.tsPlatform.drs.getSessionToken();
        } catch (e) {
        }

        // FIDO2登録レスポンス要求受付(前処理)を行う
        try {
            // ローディング開始
            this.setState({ loading: true });

            // FIDO2登録レスポンス要求受付APIを呼出す
            axios({
                method: 'POST',
                url: process.env.REACT_APP_URL_CO_SC_API_ATTESTATION_OPTIONS,
                data: { deviceName: this.state.credentialName },
                headers: {
                    'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache'
                }
            })
                .then((response) => {
                    // クレデンシャルオプション
                    const credentialOptions = response.data

                    // 引数変換処理
                    credentialOptions.user.id = Base64.toUint8Array(credentialOptions.user.id).buffer
                    credentialOptions.challenge = Base64.toUint8Array(credentialOptions.challenge).buffer
                    if (credentialOptions.excludeCredentials !== undefined) {
                        credentialOptions.excludeCredentials.forEach((listItem) => {
                            listItem.id = Base64.toUint8Array(listItem.id).buffer
                        })
                    }

                    // timeoutの値を受け取る
                    const timeout = credentialOptions.timeout + 3000

                    // デバッグログ出力フラグの取得
                    const isDebug = process.env.REACT_APP_DEBUG_ERRORLOG === 'true';

                    // WebAuthnAPI（navigator.credentials.create()）を呼び出す
                    navigator.credentials
                        .create({
                            publicKey: credentialOptions,
                        })
                        .then((newCredential) => {
                            const attestationObject = new Uint8Array(newCredential.response.attestationObject)
                            const clientDataJSON = new Uint8Array(newCredential.response.clientDataJSON)
                            const rawId = new Uint8Array(newCredential.rawId)

                            // 登録レスポンス
                            try {
                                const attestationResultUrl = process.env.REACT_APP_URL_CO_SC_API_ATTESTATION_RESULT
                                axios
                                    .post(attestationResultUrl, {
                                        id: newCredential.id,
                                        rawId: Base64.fromUint8Array(rawId, true),
                                        type: newCredential.type,
                                        response: {
                                            attestationObject: Base64.fromUint8Array(attestationObject, true),
                                            clientDataJSON: Base64.fromUint8Array(clientDataJSON, true),
                                        }
                                    },
                                    {
                                        headers: {
                                            'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                                            'Cache-Control': 'no-store',
                                            'Pragma': 'no-cache'
                                        }
                                    })
                                    .then(() => {
                                        this.setState({
                                            complete: true,
                                            errorMap: null,
                                            loading: false
                                        });
                                        window.addDataLayerScript('jmbauth_passkey_regist_completion');
                                    })
                                    .catch((error) => {
                                        if (error.response) {
                                            if (error.response.status === 400) {
                                                this.setState({
                                                    errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                                    loading: false,
                                                });
                                                // エラーメッセージ表示領域に遷移する
                                                window.location = "#JS_error";
                                            } else if (error.response.status === 401) {
                                                this.setState({
                                                    errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                                    loading: false,
                                                });
                                                // エラーメッセージ表示領域に遷移する
                                                window.location = "#JS_error";
                                            } else if (error.response.status === 500) {
                                                // エラー画面に遷移し、処理を終了する
                                                this.props.history.push({
                                                    pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                                                });
                                            } else {
                                                this.setState({
                                                    errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                                                    loading: false,
                                                });
                                                // エラーメッセージ表示領域に遷移する
                                                window.location = "#JS_error";
                                            }
                                        } else {
                                            this.setState({
                                                errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                                                loading: false,
                                            });
                                            // エラーメッセージ表示領域に遷移する
                                            window.location = "#JS_error";
                                        }
                                    })
                            } catch (error) {
                                this.setState({
                                    errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                                    loading: false,
                                });
                                // エラーメッセージ表示領域に遷移する
                                window.location = "#JS_error";
                            }

                        })
                        .catch((error) => {
                            if (error.name === 'NotSupportedError') {
                                this.setState({
                                    errorMap: isDebug
                                        ?{ ERROR: messageList.passkeySetting.M017_errorMessage002 + '(' + error.name + ')' }
                                        :{ ERROR: messageList.passkeySetting.M017_errorMessage002 },
                                    loading: false
                                });
                            } else if (error.name === 'NotAllowedError') {
                                this.setState({
                                    errorMap: isDebug
                                        ?{ ERROR: messageList.passkeySetting.M018_errorMessage003 + '(' + error.name + ')' }
                                        :{ ERROR: messageList.passkeySetting.M018_errorMessage003 },
                                    loading: false
                                });
                            } else if (error.name === 'InvalidStateError') {
                                this.setState({
                                    errorMap: isDebug
                                        ?{ ERROR: messageList.passkeySetting.M019_errorMessage004 + '(' + error.name + ')' }
                                        :{ ERROR: messageList.passkeySetting.M019_errorMessage004 },
                                    loading: false
                                });
                            } else if (error.name === 'NotReadableError') {
                                this.setState({
                                    errorMap: isDebug
                                        ?{ ERROR: messageList.passkeySetting.M020_errorMessage005 + '(' + error.name + ')' }
                                        :{ ERROR: messageList.passkeySetting.M020_errorMessage005 },
                                    loading: false
                                });
                            } else {
                                this.setState({
                                    errorMap: isDebug
                                        ?{ ERROR: messageList.passkeySetting.M021_errorMessage006 + '(' + error.name + ')' }
                                        :{ ERROR: messageList.passkeySetting.M021_errorMessage006 },
                                    loading: false
                                });
                            }
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }).finally(() => {
                            clearTimeout(timeoutId)
                        })

                    const timeoutId = setTimeout(() => {
                        this.setState({
                            errorMap: isDebug
                                ?{ ERROR: messageList.passkeySetting.M021_errorMessage007 + '(timeout)' }
                                :{ ERROR: messageList.passkeySetting.M021_errorMessage007 },
                            loading: false
                        });
                        // エラーメッセージ表示領域に遷移する
                        window.location = "#JS_error";
                    }, timeout)

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 400) {
                            this.setState({
                                errorMap:
                                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 401) {
                            this.setState({
                                errorMap:
                                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 500) {
                            // エラー画面に遷移し、処理を終了する
                            this.props.history.push({
                                pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                            });
                        }
                        else {
                            this.setState({
                                errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                                loading: false,
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                    }
                    else {
                        this.setState({
                            errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                            loading: false,
                        });
                        // エラーメッセージ表示領域に遷移する
                        window.location = "#JS_error";
                    }
                })
        } catch (error) {
            this.setState({
                errorMap: { ERROR: messageList.passkeySetting.M016_errorMessage001 },
                loading: false,
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
        } finally {
        }
    }

    // 戻るボタン押下処理
    beforePasskeySetting = () => {
        this.setState({ complete: false });
        this.getDeviceList()
        this.getUA()
    }

    // 日付フォーマット変換処理
    formatDate = (regDate) => {
        const date = new Date(regDate.replace(" ", "T") + "Z");

        const formatter = new Intl.DateTimeFormat('ja-JP', {
            timeZone: 'Asia/Tokyo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const jstDate = formatter.format(date).replace(/-/g, '/') + ' (JST)';
        return jstDate;
    }

    render() {

        // 文言リストを取得する
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // パスキー登録完了画面表示
        if (this.state.complete) {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeySetCompletion.M001_browserTitle} >
                    </Helmet>

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeySetCompletion.M002_pageTitle001}{this.state.credentialName}{messageList.passkeySetCompletion.M002_pageTitle002}</h1>
                    </div>

                    <div className="contentInner">
                        <p className="ds-text">{messageList.passkeySetCompletion.M003_guideMessage001}</p>

                        {/* 操作ボタン表示部 */}
                        <div className="buttonLayout">
                            <div className="buttonWrap buttonWrap--center">
                                <div className="ds-button ds-button--tertiary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.beforePasskeySetting}>
                                        <span className="ds-button__label">{messageList.passkeySetCompletion.M004_back}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            );
        }
        // パスキー設定画面表示
        else {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeySetting.M001_browserTitle} >
                    </Helmet>

                    { // Loadingモーダル表示
                        this.state.loading &&
                        <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
                    }

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeySetting.M002_pageTitle}</h1>
                    </div>

                    <div className="contentInner">
                        <p className="ds-text">{messageList.passkeySetting.M003_guideMessage001}</p>
                        {/* .ds-textLink */}
                        <a href={messageList.passkeySetting.M004_guideURL001} className="ds-textLink ds-textLink--linkBlank u-fw-bold" target="_blank" rel="noopener noreferrer">
                            {messageList.passkeySetting.M006_guideMessage002}&nbsp;
                            <span className="ds-textLink__icon">
                                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.passkeySetting.M005_newWindowIcon}>
                                    <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                                </svg>
                            </span>
                        </a>
                        {/* / .ds-textLink */}

                        <div id="JS_error">
                            { // エラーメッセージ表示
                                (this.state.errorMap && this.state.errorMap.ERROR) &&
                                <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                                    <div className="ds-inlineNote__details">
                                        <div className="ds-inlineNote__summary">
                                            <h2 className="ds-inlineNote__heading">
                                                <span className="ds-inlineNote__headingIcon">
                                                    <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.passkeySetting.M022_errorIconText}>
                                                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                                                    </svg>
                                                </span>
                                                <span className="ds-inlineNote__headingLabel">{messageList.passkeySetting.M022_errorBoxTitle}</span>
                                            </h2>
                                        </div>
                                        <div className="ds-inlineNote__content">
                                            <p className="ds-text">{this.state.errorMap.ERROR}</p>
                                        </div>
                                    </div>
                                </div>/* /ds-inlineNote */
                            }
                        </div>

                        {/* .ds-heading */}
                        <div className="ds-heading ds-heading--sm">
                            <h2 className="ds-heading__title">{messageList.passkeySetting.M007_pageTitleSub}</h2>
                        </div>
                        {/* / .ds-heading */}

                        {
                            (!this.state.deviceList || this.state.deviceList.length === 0) &&
                            <p className="ds-text">{messageList.passkeySetting.M011_guideMessage002}</p>
                        }

                        {
                            (this.state.deviceList && this.state.deviceList.length > 0) &&
                            <ul className="listPasskey">
                                {this.state.deviceList.map((device, index) => (
                                    <li key={index} className="listPasskey__item">
                                        <div className="listPasskey__name">
                                            <span id={`WA_passkeyTitle-${index + 1}`} className="listPasskey__nameString">{device.credentialName}</span>
                                            {/* .ds-button */}
                                            <div className="ds-button ds-button--tertiary ds-button--small">
                                                <button className="ds-button__trigger" type="button" aria-describedby={`WA_passkeyTitle-${index + 1}`} onClick={() => this.toPasskeyChange(device)}>
                                                    <span className="ds-button__label">{messageList.passkeySetting.M014_change}</span>
                                                </button>
                                            </div>
                                            {/* / .ds-button */}
                                        </div>
                                        <div className="listPasskey__date">
                                            <span className="listPasskey__dateLabel">{messageList.passkeySetting.M009_colname002}</span>
                                            <span className="listPasskey__dateString">{this.formatDate(device.regDate)}</span>
                                        </div>
                                        <div className="listPasskey__action">
                                            {/* .ds-button */}
                                            <div className="ds-button ds-button--tertiary ds-button--small">
                                                <button className="ds-button__trigger" type="button" aria-describedby={`WA_passkeyTitle-${index + 1}`} onClick={() => this.toPasskeyDelete(device)}>
                                                    <span className="ds-button__icon ds-button__icon--left">
                                                        <svg className="ds-icon" width="20" height="20" aria-hidden="true">
                                                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_delete`}></use>
                                                        </svg>
                                                    </span>
                                                    <span className="ds-button__label">{messageList.passkeySetting.M015_delete}</span>
                                                </button>
                                            </div>
                                            {/* / .ds-button */}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        }

                        {/* 操作ボタン表示部 */}
                        <div className="buttonLayout">
                            <div className="buttonWrap buttonWrap--center">
                                {!this.state.webAuthnFlg &&
                                <div class="buttonWrap__text">
                                    <p className="ds-text u-fz-12">{messageList.passkeySetting.M023_notice001}</p>
                                </div>
                                }
                                {/* .ds-button */}
                                <div className={this.state.webAuthnFlg ? "ds-button ds-button--primary ds-button--large" : "ds-button ds-button--primary ds-button--large is-disabled"}>
                                    <button className="ds-button__trigger" type="button" disabled={!this.state.webAuthnFlg} onClick={this.register}>
                                        <span className="ds-button__label">{messageList.passkeySetting.M012_register}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                            <div className="buttonWrap buttonWrap--left">
                                {/* .ds-button */}
                                <div className="ds-button ds-button--tertiary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.close}>
                                        <span className="ds-button__label">{messageList.passkeySetting.M013_close}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                        </div>
                        {/* / .buttonLayout */}
                    </div>

                </section>
            );
        }

    }
}

export default PasskeySetting
